"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.init = exports.GO_FORWARD = exports.GO_BACK = exports.GO = exports.REPLACE = exports.PUSH = exports.INIT = void 0;

var _index = require("./index");

var actionType = (0, _index.actionTypeCreator)('@relient/history');
var INIT = actionType('INIT');
exports.INIT = INIT;
var PUSH = actionType('PUSH');
exports.PUSH = PUSH;
var REPLACE = actionType('REPLACE');
exports.REPLACE = REPLACE;
var GO = actionType('GO');
exports.GO = GO;
var GO_BACK = actionType('GO_BACK');
exports.GO_BACK = GO_BACK;
var GO_FORWARD = actionType('GO_FORWARD');
exports.GO_FORWARD = GO_FORWARD;
var init = (0, _index.createAction)(INIT);
exports.init = init;
var push = (0, _index.createAction)(PUSH);
exports.push = push;
var replace = (0, _index.createAction)(REPLACE);
exports.replace = replace;
var go = (0, _index.createAction)(GO);
exports.go = go;
var goBack = (0, _index.createSimpleAction)(GO_BACK);
exports.goBack = goBack;
var goForward = (0, _index.createSimpleAction)(GO_FORWARD);
exports.goForward = goForward;